import api from "../../services/api";
import {
  GET_WASH_CENTRES_FAILURE,
  GET_WASH_CENTRES_REQUEST,
  GET_WASH_CENTRES_SUCCESS,
} from "./ActionType";

const getWashCentresRequest = () => ({
  type: GET_WASH_CENTRES_REQUEST,
});

const getWashCentresSuccess = (centres) => ({
  type: GET_WASH_CENTRES_SUCCESS,
  payload: centres,
});

const getWashCentresFailure = (error) => ({
  type: GET_WASH_CENTRES_FAILURE,
  payload: error,
});

export const getWashCentres = () => async (dispatch) => {
  dispatch(getWashCentresRequest());
  try {
    // Backend controller is mapped at /api/wash-centres
    const response = await api.get("/wash-centres", {
      withCredentials: true,
    });
    dispatch(getWashCentresSuccess(response.data));
  } catch (error) {
    dispatch(getWashCentresFailure(error));
  }
};


